
import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface CustomerAddressInfoProps {
  address: string;
  setAddress: (address: string) => void;
  country: string;
  setCountry: (country: string) => void;
  region: string;
  setRegion: (region: string) => void;
  municipality: string;
  setMunicipality: (municipality: string) => void;
  saving: boolean;
}

const CustomerAddressInfo = ({
  address,
  setAddress,
  country,
  setCountry,
  region,
  setRegion,
  municipality,
  setMunicipality,
  saving
}: CustomerAddressInfoProps) => {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="address">Adresse</Label>
        <Input
          id="address"
          value={address || ''}
          onChange={(e) => setAddress(e.target.value)}
          placeholder="Adresse"
          disabled={saving}
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-2">
          <Label htmlFor="country">Pays</Label>
          <Input
            id="country"
            value={country || ''}
            onChange={(e) => setCountry(e.target.value)}
            placeholder="Pays"
            disabled={saving}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="region">Région</Label>
          <Input
            id="region"
            value={region || ''}
            onChange={(e) => setRegion(e.target.value)}
            placeholder="Région"
            disabled={saving}
          />
        </div>

        <div className="space-y-2">
          <Label htmlFor="municipality">Ville</Label>
          <Input
            id="municipality"
            value={municipality || ''}
            onChange={(e) => setMunicipality(e.target.value)}
            placeholder="Ville"
            disabled={saving}
          />
        </div>
      </div>
    </>
  );
};

export default CustomerAddressInfo;
